import React from 'react';
import type { ButtonV2Props } from '@withjoy/joykit';
import { ButtonV2 } from '@withjoy/joykit';
import type { ButtonOverrides } from '@withjoy/joykit/components/ButtonV2/Button.types';
import { useTranslation } from '@shared/core';

const cashFundCtaOverrides: ButtonOverrides = {
  Root: {
    props: {
      color: 'white',
      backgroundColor: 'mono14',
      _hover: {
        color: 'white',
        backgroundColor: 'mono11',
      },
      _active: {
        color: 'white',
        backgroundColor: 'black',
      },
      _disabled: {
        color: 'mono8',
        backgroundColor: 'mono3',
      },
    },
  },
};

export const EditCashFundCta = (props: ButtonV2Props) => {
  const { tq } = useTranslation('catalogRegistry');
  return (
    <ButtonV2
      fullWidth={true}
      marginTop={4}
      data-quickadd={true}
      shape="rounded"
      overrides={cashFundCtaOverrides}
      {...props}
    >
      {tq`Edit and Add`}
    </ButtonV2>
  );
};
